module.exports = __webpack_public_path__ + "img/favicon200x200.0b2b8012.png";